<div class="auth-card">
  <div class="auth-card__header">
    <img class="auth-card__logo" [src]="authLogo" alt="logo" />
    @if (!emailSent) {
      <h1 class="auth-card__title">{{ 'forgot_your_password' | translate }}</h1>
      <p class="auth-card__subtitle">{{ 'forgot_your_password_description' | translate }}</p>
    }
    @if (emailSent) {
      <h1 class="auth-card__title">{{ 'check_your_email' | translate }}</h1>
      <p class="auth-card__subtitle">{{ getCheckYourEmailDescription() }}</p>
    }
  </div>

  <form class="auth-card__form" [formGroup]="forgotPasswordForm">
    @if (!emailSent) {
      <div class="auth-card__fields">
        <div class="auth-field">
          <label class="auth-field__label" for="forgot-email">{{ 'email_address' | translate }}</label>
          <input
            id="forgot-email"
            type="email"
            formControlName="email"
            required
            autocomplete="email"
            class="auth-field__input"
          />
          @if (email.invalid) {
            <mat-error>
              @if (email.errors?.required) {
                <span>{{ 'please_enter_email' | translate }}</span>
              }
              @if (email.errors?.remote) {
                <span>{{ email.errors?.remote }}</span>
              }
            </mat-error>
          }
        </div>
      </div>
    }

    @if (!emailSent) {
      <button
        class="auth-card__submit"
        mat-raised-button
        [disabled]="!!forgotPasswordForm.invalid"
        [loading]="isSubmitting"
        (click)="sendRemind()"
      >
        {{ 'continue' | translate }}
      </button>
    }

    @if (emailSent) {
      <button class="auth-card__submit" mat-raised-button>
        {{ 'resend_email' | translate }}
      </button>
    }

    <div class="auth-card__footer-link">
      <a routerLink="/">{{ 'back_to_home' | translate }}</a>
    </div>
  </form>
</div>
